<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import backIcon from 'src/components/cabinet/#assets/left-icon.svg'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte'
    import {userProfile} from 'src/services/auth'
    import {getReferralInfoList} from 'src/components/cabinet/#services/myReferrals'
    import {Link} from 'svelte-routing'
    import {getDateFormat} from 'src/components/cabinet/#common/helpers'

    let currentPage = 0
    let perPage = 30

    $: getReferralInfoList.send({ data: { userId: $userProfile.userId, page: currentPage+1, perPage } })
</script>

<svelte:head>
    <title>Referrals</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="page-title">
                <Link to="referrals" class="btn btn-second back"><img src={backIcon} alt=""> Back</Link>All referrals
            </div>
            <div class="row">
                <div class="col-lg-11 col-xl-10 col-xxl-6">
                    <div class="referrals-list-wrapper">
                        {#if $getReferralInfoList.loading}
                            <div class="referrals-list">Loading...</div>
                        {:else if $getReferralInfoList.hasValue && $getReferralInfoList.value.totalCount}
                            {#if $getReferralInfoList.value.totalCount > 0}
                                <div class="referrals-list">
                                    <div class="my-referrals-table">
                                        <div class="referrals-table-header">
                                            <div>Referral</div>
                                            <div>Date</div>
                                        </div>
                                        <div class="referrals-table-body">
                                            {#each $getReferralInfoList.value.data as {nickname, registryDate}}
                                                <div class="referrals-table-row">
                                                    <div class="notranslate">{nickname.replace(/#([^#]+)$/, '')}</div>
                                                    <div>{getDateFormat(registryDate)}</div>
                                                </div>
                                            {/each}
                                        </div>
                                        <Pagination bind:currentPage={currentPage} totalCount={$getReferralInfoList.value.totalCount} {perPage}/>
                                    </div>
                                </div>
                            {:else}
                                Empty
                            {/if}
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .referrals-list-wrapper {
        border-radius: 20px;
        border: 2px solid #353064;
        background: #1a183a;
        padding: 30px;
        height: 100%;
    }

    .referrals-table-header {
        display: flex;
        width: 100%;
        margin: 0 0 30px;
    }

    .referrals-table-header > div {
        width: 50%;
        padding: 11px 20px;
        background: #494591;
        color: #c3c0ed;
        font-size: 17px;
        line-height: 20px;
        font-weight: 500;
    }

    .referrals-table-header > div:first-child {
        border-radius: 8px 0 0 8px;
    }

    .referrals-table-header > div:last-child {
        border-radius: 0 8px 8px 0;
    }

    .referrals-table-row {
        display: flex;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 2px solid #343168;
    }

    .referrals-table-row > div {
        width: 50%;
        padding: 0 20px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
    }

    .referrals-list :global(ul.pagination) {
        margin: 30px auto 5px;
        justify-content: center;
    }

    @media(max-width: 768px) {
        .referrals-table-header > div {
            padding: 10px 20px;
            font-size: 16px;
        }

        .referrals-table-row > div {
            padding: 10px 20px;
            font-size: 15px;
        }

        .referrals-list-wrapper {
            margin-top: 16px;
            padding: 20px 16px;
            border-radius: 16px;
        }

        .referrals-table-header > div {
            padding: 8px 16px;
            font-size: 14px;
        }

        .referrals-table-row > div {
            padding: 0 16px;
            font-size: 13px;
        }

        .referrals-table-row {
            padding-bottom: 12px;
            margin-bottom: 12px;
            border-bottom: 1px solid #343168;
        }

        .referrals-table-header {
            margin-bottom: 24px;
        }
    }
</style>
